exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader{width:100%;height:150px;text-align:center}img.uploaded-img{width:100%;height:100%;border-radius:4px;border:1px solid #ccc;-o-object-fit:contain;object-fit:contain}.button.add-btn,.button.delete-btn{position:absolute;top:0;right:0;left:0;width:100%;height:100%;font-size:18px}.button.delete-btn{background:rgba(0,0,0,.33);color:#fff;font-weight:700}", ""]);

// exports
